import DeviceStorage from "src/components/DeviceStorage/DeviceStorage";
import store from "src/store";
import Utils from "src/utils/Utils";
import { authdevice } from '../../requests/loader';
import utilsIsSticky from 'src/utils/user/IsSticky';
import { receiveAuthDevice, receiveIsLoggedIn, initialState } from "src/reducers/user";
import LoadPtv from 'src/AAF/LoaderExp/LoadPtv';
import { playFullMedia } from '../../actions/playmedia';
import { AAFPLAYER_STOP } from '../../AAFPlayer/constants';
import LayersControl from '../../utils/LayersControl';
const ISLOGGEDIN_ERROR_CODE = 'usuario_no_logueado';
const FROM_APP = 'App';
const FROM_INTERVAL = 'Interval';
const LANDING_PATH = '/landing';
const AUTH_DEVICE_PATH = '/authdevice';
const HOME_PATH = '/node/homeuser';

const isLostSessionError = function(response) {
    if(Utils.isNullOrUndefined(response)) return false;
    let isSessionError = false;
    if(response 
        && response.errors
        && response.errors.code) {
            isSessionError = response.errors.code === ISLOGGEDIN_ERROR_CODE;
        }

    return isSessionError;
};

const isPTVUSer = function() {
    const state = store.getState();
    const { user }  = state;
    
    return Utils.isPTV(user);
}

const getUser = () =>{
  const {user = {}} = store.getState() || {};
  return user;
}

// callback cuando necesitemos retomar el flujo desde donde vino el error
// para sync 
const sendAuthdevice = function() {
  return new Promise((resolve, reject) => {
    authdevice().then(result => {
      const user = result && result.response ? result.response : {};
      if (result.response) {
          DeviceStorage.setItem('fromAuthDevice', 'true');
      }
      user.subregion && DeviceStorage.setItem('sub_region', user.subregion);
      store.dispatch(receiveAuthDevice(user));
      Utils.setCustomAttribute();

      const pushSession = Utils.getApaMetadataKey('sticky_session', '{"push_session":false,"user_id":false}', 'push_session');
      if (pushSession) utilsIsSticky.getPushSession();

      resolve(result);

  }).catch(err => {
    reject(err);
  });
  }) 
}

const gotoLanding = (history) => {
    stopPlayer();
    history && history.replace && 
    typeof history.replace === 'function' &&
    history.replace(LANDING_PATH);
    LayersControl.showUX(true);
}

const gotoAuthDevice = (history) => {
    stopPlayer()
    history && history.replace && 
    typeof history.replace === 'function' &&
    history.replace(AUTH_DEVICE_PATH);
    LayersControl.showUX(true);
}

const reloadApp = () => {
  stopPlayer();
  window.location.assign('/');
}

const filterIsloggedin = function(isloggedinResponse, from = null, history) {
    console.log('[filterIsloggedin]:: ', isloggedinResponse, from, history);
    const user = isloggedinResponse && (isloggedinResponse.response || isloggedinResponse.data) ? isloggedinResponse.response || isloggedinResponse.data: {};
    const isIPTVUser = isPTVUSer();
    console.log('[filterIsloggedin]:: isIPTVUser', isIPTVUser);
    console.log('[filterIsloggedin]:: user 01', user);
    
    if(isIPTVUser) {
        // Es respuesta válida en http status 200, pero puede ser que no
        // sea respuesta bien formada
        let _isLostSessionError = false;
        if(isLostSessionError(isloggedinResponse)) {
          _isLostSessionError = true;
        }

        // Ya es ptv aquí, si es lost session error y si no es el 
        // primer isloggedin que se llama desde App/index 
        if((from === null || from === FROM_INTERVAL) && _isLostSessionError) {
          if (LoadPtv.isEnableOttExperience()){
            reloadApp();
          } else {
            // Se manda a llamar authdevice nuevamente
            sendAuthdevice().catch((err)=>{
              gotoAuthDevice(history);
            });
          }
        }
        else {
          // Si es respuesta válida
          if(user && user.region) {
            store.dispatch(receiveIsLoggedIn(user));
            Utils.setCustomAttribute();
            if (window.location.href.includes(LANDING_PATH)){
              history.replace(HOME_PATH);
            }
          }
          else {
            // Si no es iptv user o es el *primer* isloggedin, 
            // se hace el dispatch normal
            // Sólo es iptv y no es respuesta válida no se toca el response anterior
            if(!isIPTVUser || from === FROM_APP) {
              console.log('[filterIsloggedin]:: user 02', user);
              store.dispatch(receiveIsLoggedIn(isloggedinResponse ? user : initialState));
              //* Se manda a guardar en localStorage la respuesta de isloggedin
              DeviceStorage.setItem('CMR_Experience_user_login', JSON.stringify(isloggedinResponse));
              Utils.setCustomAttribute();
            }
          }
        }
      }
      // Se deja como estaba, OTT
      else {
        const previousUser = getUser();
        user.msg = isloggedinResponse && isloggedinResponse.msg ? isloggedinResponse.msg : '';
        user.errors = isloggedinResponse && isloggedinResponse.errors ? isloggedinResponse.errors : '';
        store.dispatch(receiveIsLoggedIn(user));
        Utils.setCustomAttribute();
    
        if (isLoggedIn(previousUser, user)) {
          DeviceStorage.setItem('hadLoginSuccess', '1')
          if (window.location.href.includes(LANDING_PATH)){
            history.replace(HOME_PATH);
          }
        } else
        if (isLoggedOut(previousUser, user)) {
          if (LoadPtv.isEnableOttExperience()){ 
            gotoLanding(history);
          } else {
            gotoAuthDevice(history);
          }
        }
      }
};


const isLoggedIn = (previous, current) => {
    const {isLoggedIn} = previous;
    const {is_user_logged_in} = current;
    return isLoggedIn === false && is_user_logged_in === 1;
}

const isLoggedOut = (previous, current) => {
  const {isLoggedIn} = previous;
  const {is_user_logged_in} = current;
  return isLoggedIn === true && is_user_logged_in !== 1;
}

const stopPlayer = () =>{
  const nullPlayer = {
    ispip: false,
    islive: false,
    ispreview: false,
    playerstate: AAFPLAYER_STOP,
    event: null,
    videoid: null,
  };
  try {
    store.dispatch(playFullMedia(nullPlayer));
  } catch (error) {
    console.error('Error [stopPlayer]', error)
  }
}

const Resilence = {
    filterIsloggedin,
    sendAuthdevice,
    isPTVUSer,
};

export { Resilence, FROM_APP };


// WEBPACK FOOTER //
// ./src/AAF/Resilence/main.js